import React, { useState, useEffect } from "react";
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from "@headlessui/react"; 
import { getToken } from "../../utils/tokenUtils";
import axios from "axios";

const EmergencyContactsForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, // Added errors prop to display validation messages
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [query, setQuery] = useState("");
  const [users, setUsers] = useState([]);
  const token = getToken();

  useEffect(() => {
      const fetchUsers = async (page = 1) => {
        try {
          const res = await axios.get(`https://hrmsnew.prepstripe.com/api/users?page=${page}`, {
              headers: {
                  contentType: "application/json",
                  Authorization: `Bearer ${token}`,
              },
          }); // update with actual endpoint
          setUsers(res.data.data.data);
        } catch (error) {
          console.error("Failed to fetch users:", error);
        }
      };
  
      fetchUsers();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // setFormData((prev) => ({ ...prev, [name]: value }));
    
    if (name === "contact_phone") {
      // Allow only digits and limit to 10 characters
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (name === "contact_name" || name === "relationship") {
      const filteredValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: filteredValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(formData.contact_email)) {
      alert("Please enter a valid email address.");
      return
    }

    if (!formData.contact_name.trim()) {
      alert("Please enter a valid contact name.");
      return
    }
    
    const submissionData = new FormData(); // Use FormData for file upload
    submissionData.append("employee_id", formData.employee_id);
    submissionData.append("contact_name", formData.contact_name);
    submissionData.append("relationship", formData.relationship || ""); // Optional field
    submissionData.append("contact_phone", formData.contact_phone);
    submissionData.append("contact_email", formData.contact_email);

    onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
  };

  const handleUserSelect = (selectedUser) => {
    setFormData((prev) => ({
    ...prev,
    employee_id_id: selectedUser.employee_id, // assuming `id` is needed for backend
    }));
  };

  const filteredUsers = query === ""
  ? users
  : users.filter(
      (user) =>
        user.employee_id &&
        user.employee_id.toLowerCase().includes(query.toLowerCase())
    );

      
  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      {/* Employee ID Field */}
      <div>
        <label htmlFor="employee_id" className="block dark:text-white text-sm font-medium text-gray-700">
          Employee ID <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="text"
          id="employee_id"
          name="employee_id"
          disabled
          readOnly
           value={formData.employee_id}
          onChange={handleChange}
          className="mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border border-gray-300 rounded-md p-2 bg-gray-200"
          required
        />
        {errors.employee_id && <p className="text-red-500 text-sm mt-1">{errors.employee_id}</p>}
      </div>

      {/* <label htmlFor="employee_id" className="block text-sm font-medium text-gray-700">Employee ID</label>
      <Combobox value={formData.employee_id} onChange={(employee_id) => {
          const selectedUser = users.find(u => u.employee_id === employee_id);
          if (selectedUser) {
              setFormData(prev => ({ ...prev, employee_id }));
              handleUserSelect(selectedUser);
          }
      }}>
        <div className="relative">
          <ComboboxInput
            id="employee_id"
            className="w-full border rounded-md p-2"
            onChange={(e) => setQuery(e.target.value)}
            displayValue={(employee_id) => employee_id || ""}
            placeholder="Search and select user..."
          />
          <ComboboxOptions className="absolute z-10 w-full bg-white border mt-1 rounded-md shadow-lg max-h-60 overflow-auto">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <ComboboxOption key={user.employee_id} value={user.employee_id} className="cursor-pointer px-4 py-2 hover:bg-blue-100">
                  {user.employee_id}
                </ComboboxOption>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-500">No users found</div>
            )}
          </ComboboxOptions>
        </div>
      </Combobox> */}

                
      {/* Contact Name Field */}
      <div>
        <label htmlFor="contact_name" className="block dark:text-white text-sm font-medium text-gray-700">
          Contact Name <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="text"
          id="contact_name"
          name="contact_name"
          value={formData.contact_name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            errors.contact_name ? "border-red-500" : "border-gray-300"
          }`}
          maxLength={50}
          pattern="[A-Za-z\s]+"
          title="Only letters and spaces allowed"
          required
        />
        {errors.contact_name && (
          <p className="text-red-500 text-sm mt-1">{errors.contact_name}</p>
        )}
      </div>


      {/* Relationship Field */}
      <div>
        <label htmlFor="relationship" className="block dark:text-white text-sm font-medium text-gray-700">
          Relationship 
        </label>
        <input
          type="text"
          id="relationship"
          name="relationship"
          value={formData.relationship}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            errors.relationship ? "border-red-500" : "border-gray-300"
          }`}
          maxLength={30}
          pattern="[A-Za-z\s]+"
          title="Only letters and spaces allowed"
        />
        {errors.relationship && (
          <p className="text-red-500 text-sm mt-1">{errors.relationship}</p>
        )}
      </div>


      {/* Contact Phone Field */}
      <div>
        <label htmlFor="contact_phone" className="block dark:text-white text-sm font-medium text-gray-700">
          Contact Phone <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="tel"
          id="contact_phone"
          name="contact_phone"
          value={formData.contact_phone}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            errors.contact_phone ? "border-red-500" : "border-gray-300"
          }`}
          maxLength={10}
          pattern="[0-9]{10}"
          required
        />
        {errors.contact_phone && (
          <p className="text-red-500 text-sm mt-1">{errors.contact_phone}</p>
        )}
      </div>


      {/* Contact Email Field */}
      <div>
          <label htmlFor="contact_email" className="block dark:text-white text-sm font-medium text-gray-700">
              Contact Email <span className="text-red-500 ml-1">*</span>
          </label>
          <input
              type="email"
              id="contact_email"
              name="contact_email"
              value={formData.contact_email}
              onChange={handleChange}
              className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
                  errors.contact_email ? "border-red-500" : "border-gray-300"
              }`}
              required
          />
          {errors.contact_email && <p className="text-red-500 text-sm mt-1">{errors.contact_email}</p>}
      </div>


      {/* Form Actions */}
      <div className="flex justify-between items-center space-x-4">
        <button
          type="button"
          onClick={closeModal}
          className="px-4 py-2 dark:bg-gray-900 dark:text-white bg-gray-500 text-white rounded-md hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {initialValues.contact_id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default EmergencyContactsForm;
